import gql from "graphql-tag";

export const reorderArticlesMutation = gql`
  mutation reorderArticles($order: [ID!], $sectionId: ID!) {
    reorderArticles(order: $order, sectionId: $sectionId) {
      id
    }
  }
`;
